import { render, staticRenderFns } from "./ParameterList.vue?vue&type=template&id=84fc5d70&scoped=true&"
import script from "./ParameterList.vue?vue&type=script&lang=js&"
export * from "./ParameterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fc5d70",
  null
  
)

export default component.exports